import { render, staticRenderFns } from "./WebCamModal.vue?vue&type=template&id=3cc98b5a&"
import script from "./WebCamModal.vue?vue&type=script&lang=js&"
export * from "./WebCamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports